import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import { hasGlobalFeature } from 'selectors';
import * as assignmentsSelectors from 'selectors/learn/assignments';
import { usePageTitle } from 'components/shared/PageTitle';
import AssignmentsGroup from './AssignmentsGroup';
import * as sortOptions from './sortOptions';

const Assignments = ({
  assignments: { incomplete, awaitingGrade, completed },
  hasFeatureChangeAssignmentsToResources,
}) => {
  usePageTitle(
    hasFeatureChangeAssignmentsToResources
      ? t('resources.title')
      : t('learn.sidebar.assignments'),
  );

  return (
    <div>
      {!isEmpty(incomplete) && (
        <AssignmentsGroup
          title={
            hasFeatureChangeAssignmentsToResources
              ? t('resources.incomplete.title')
              : t('assignments.incomplete.title')
          }
          assignments={incomplete}
        />
      )}
      {!isEmpty(awaitingGrade) && (
        <AssignmentsGroup
          title={t('assignments.grade_pending.title')}
          assignments={awaitingGrade}
        />
      )}
      {!isEmpty(completed) && (
        <AssignmentsGroup
          title={
            hasFeatureChangeAssignmentsToResources
              ? t('resources.completed.title')
              : t('assignments.completed.title')
          }
          assignments={completed}
          defaultSortOption={sortOptions.MOST_RECENT}
          sortOptions={sortOptions.completedAssignments}
          sortable
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  assignments: assignmentsSelectors.allAssignmentsByType(state),
  hasFeatureChangeAssignmentsToResources: hasGlobalFeature(
    state,
    'change_assignments_to_resources',
  ),
});

export default connect(mapStateToProps)(Assignments);
